import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_CATEGORY = "SHOP:GET_PRODUCT_CATEGORY";

export const getProductCategoryAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_PRODUCT_CATEGORY as typeof GET_PRODUCT_CATEGORY,
  organization,
  id,
});

export type GetProductCategoryAction = ReturnType<
  typeof getProductCategoryAction
>;
